@import "config";

.container {
	@include hstack($spacing-inline-quarck);

	border: 1px solid $color-primary-pure;
	background: $color-primary-lightest;
	color: $color-primary-darkest;
	padding: $spacing-inline-quarck $spacing-inline-nano;
	border-radius: $border-radius-sm;
	gap: $spacing-inline-quarck;

	& > div {
		@include flex(row, center, center);
	}
}

.closeIcon {
	cursor: pointer;
}